import {useCallback, useEffect, useState} from "react";
import api from "../..";
import {useBlockUI} from "../../../shared/services/block-ui-service";
import {BaseResponse} from "../../../models/base-response";

export interface ProgrammingLocationRefreshAccepted {
    message: string;
}

const useProgrammingLocationService = () => {
    const [loading, setLoading] = useState<boolean>(false);
    const blockUI = useBlockUI();

    useEffect(() => {
        blockUI?.setActive(loading);
    }, [loading]);

    /**
     * Atualiza programações ativas com os últimos logs de rastreamento
     */
    const refreshProgrammingLocations = useCallback(async (): Promise<ProgrammingLocationRefreshAccepted> => {
        try {
            setLoading(true);
            const response = await api.post<BaseResponse<ProgrammingLocationRefreshAccepted>>(
                '/v1/backoffice/programming-location/refresh'
            );
            return response?.data?.data ?? {
                message: 'Atualização de localizações enfileirada.'
            };
        } catch (error) {
            throw error;
        } finally {
            setLoading(false);
        }
    }, []);

    return {
        loading,
        refreshProgrammingLocations
    };
};

export default useProgrammingLocationService; 